// extracted by mini-css-extract-plugin
export default {"formTextareaContainer":"TextArea_formTextareaContainer__Xcqid","formtextArea":"TextArea_formtextArea__G+Ndd","formtextareaMaxChars":"TextArea_formtextareaMaxChars__zMWHv"};